import { wrapWebPublishableData } from "../AuthData/WebPublishableData";
import { ProfileButton } from "./ProfileButton";
import PhotosIcon from "../Icons/PhotosIcon";
import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { getChildMedia } from "../../helpers/helpers";
const shimmerProps = { height: "45px" };

export function ViewGalleryButton(props) {
  const { childMedia } = props;
  const [toggler, setToggler] = useState(false);

  if (!childMedia || !childMedia.length) {
    return null;
  }

  const childMediaData = getChildMedia(childMedia);
  const hasChildMedia = childMediaData.urls.length ? true : false;

  if (!hasChildMedia) {
    return null;
  }

  const onSlideChange = (fsLightbox) => {
    const sources = fsLightbox.elements.sources;

    for (let i = 0; i < sources.length; i++) {
      const source = sources[i].current;
      if (source && source.tagName === "VIDEO" && !source.paused) {
        source.pause();
      }
    }
  };

  return (
    <>
      <FsLightbox
        toggler={toggler}
        sources={childMediaData["urls"]}
        types={childMediaData["types"]}
        customAttributes={childMediaData["attributes"]}
        captions={childMediaData["captions"]}
        disableThumbs={true}
        onSlideChange={onSlideChange}
      />
      <ProfileButton
        classList="profile-button__view-gallery"
        icon={<PhotosIcon />}
        requires={["child"]}
        handleClick={() => {
          setToggler(!toggler);
        }}
        {...props}
      >
        View photos
      </ProfileButton>
    </>
  );
}

export default wrapWebPublishableData(ViewGalleryButton, { shimmerProps });
